import { createOrderParams } from './orderUtils'

// NOTE : Please keep the default behaviors here in line with Shift4 use cases. Conditionalize
// FreedomPay specific behaviors.

const responseStatuses = {
  1: 'No response data exists',
  2: 'Card reader still offline',
  3: 'Transaction declined during replay',
  4: 'Transaction approved',
  5: 'Voided without communicating with the server',
}

const isPaxResponse = (data) => data.reasonText || data.message

const responseRefNum = (data) => {
  if (isPaxResponse(data)) return data.refNum

  return data.responseStatus
}

export const statusCheckComplete = (data) => {
  if (!data) return false

  const responseRef = responseRefNum(data)

  if (!isPaxResponse(data)) return [3, 4].includes(responseRef)

  // TODO(mkramerl): This is for legacy compatibility; remove at some point.
  if (!responseRef) return true

  return responseRef <= 5000 || responseRef >= 9001
}

export const responseStatusString = (responseStatus) => responseStatuses[responseStatus]

export const approvedOfflineThenDeclined = (data) => {
  const responseRef = responseRefNum(data)
  if (!isPaxResponse(data)) {
    return responseRef === 3
  }

  // TODO(mkramerl): This is for legacy compatibility; remove at some point.
  if (!responseRef) {
    if (data.reasonText === 'DECLINE' || data.message === 'DECLINE') {
      return true
    }

    if (data.reasonText === 'NOT FOUND' || data.message === 'NOT FOUND') {
      return true
    }

    if (data.reasonText === 'APPROVED OFFLINE' || data.message === 'APPROVED OFFLINE') {
      const receiptData = data.receiptData

      if (receiptData?.approvalCode === 'D') {
        return true
      }
    }
  }

  return responseRef >= 9001 && responseRef <= 9999
}

export const isOfflineApproval = (order) => {
  const cardReaderData = order?.cardReaderData ?? {}
  const userAttributes = createOrderParams(order)?.userAttributes ?? order?.userAttributes ?? {}
  const requestId = cardReaderData.requestId || ''

  return cardReaderData?.isOfflineApproval || userAttributes?.isOfflineApproval || requestId.substring(0, 3) === '00Y'
}
